import type { ActionRequiredItemEntity } from "../entities/BooksHealthEntity";
import type { BooksHealthRepository } from "../repositories/BooksHealthRepository";

export class GetBooksHealthActionRequiredUseCase {
  constructor(private readonly repository: BooksHealthRepository) {}

  async execute(): Promise<ActionRequiredItemEntity[]> {
    return this.repository.getBooksHealthActionRequired();
  }
}

